import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c11ad66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-5 align-items-center\" data-v-2c11ad66><div data-v-2c11ad66><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2c11ad66><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-2c11ad66></rect><g clip-path=\"url(#clip0_3443_1505)\" data-v-2c11ad66><path opacity=\"0.3\" d=\"M21.2327 27.5H14.4931V21.25H12.2466V31.25C12.2466 31.9414 12.7486 32.5 13.3699 32.5H22.3559C22.9772 32.5 23.4792 31.9414 23.4792 31.25V21.25H21.2327V27.5ZM32.2757 18.0547L29.2815 13.0547C29.0709 12.707 28.7199 12.5 28.3443 12.5H14.121C13.7455 12.5 13.3944 12.707 13.1873 13.0547L10.1932 18.0547C9.69471 18.8867 10.2283 20 11.1269 20H31.342C32.2371 20 32.7706 18.8867 32.2757 18.0547ZM27.9722 31.875C27.9722 32.2188 28.225 32.5 28.5338 32.5H29.6571C29.966 32.5 30.2187 32.2188 30.2187 31.875V21.25H27.9722V31.875Z\" fill=\"#203972\" data-v-2c11ad66></path><path d=\"M32.2756 18.0547L29.2814 13.0547C29.0708 12.707 28.7198 12.5 28.3442 12.5H14.1209C13.7453 12.5 13.3943 12.707 13.1872 13.0547L10.193 18.0547C9.69459 18.8867 10.2281 20 11.1267 20H31.3419C32.237 20 32.7705 18.8867 32.2756 18.0547Z\" fill=\"#203972\" data-v-2c11ad66></path></g><defs data-v-2c11ad66><clipPath id=\"clip0_3443_1505\" data-v-2c11ad66><rect width=\"22.4652\" height=\"25\" fill=\"white\" transform=\"translate(10 10)\" data-v-2c11ad66></rect></clipPath></defs></svg></div><div data-v-2c11ad66><p class=\"m-0 subtitulo cor_texto_1\" data-v-2c11ad66>Dados da Loja</p></div></div><div class=\"px-5\" data-v-2c11ad66><hr class=\"text-muted m-0\" data-v-2c11ad66></div>", 2)
const _hoisted_3 = { class: "d-flex flex-column justify-content-between p-5" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column gap-1"
}
const _hoisted_5 = { class: "fs-6 d-flex flex-row gap-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Grupo", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "d-flex gap-3 mt-3" }
const _hoisted_12 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_13 = { class: "fs-6 d-flex flex-row gap-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "CNPJ", -1))
const _hoisted_15 = {
  key: 0,
  class: "ms-1 legenda text-danger"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_22 = { class: "fs-6 d-flex flex-row gap-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Nome Fantasia", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "d-flex gap-3 p-0 col-12 mb-3 mt-3" }
const _hoisted_29 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_30 = { class: "fs-8 d-flex flex-row gap-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Razão Social", -1))
const _hoisted_32 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fc0101"} }, "*", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda text-danger" }, "Campo obrigatório", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Telefone", -1))
const _hoisted_38 = { class: "d-flex gap-3" }
const _hoisted_39 = {
  class: "d-flex flex-column gap-1",
  style: {"flex":"1"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "E-mail", -1))
const _hoisted_41 = {
  class: "d-flex flex-column gap-1",
  style: {"flex":"1"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Data criação", -1))
const _hoisted_43 = { class: "d-flex gap-3 mt-3" }
const _hoisted_44 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Responsavel", -1))
const _hoisted_46 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Rede", -1))
const _hoisted_48 = { class: "d-flex gap-3 mt-3" }
const _hoisted_49 = { class: "d-flex flex-column gap-1" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Endereço", -1))
const _hoisted_51 = { class: "d-flex flex-column gap-1" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "CEP", -1))
const _hoisted_53 = { class: "d-flex flex-column gap-1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "UF", -1))
const _hoisted_55 = { class: "d-flex gap-3 mt-3" }
const _hoisted_56 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Logradouro", -1))
const _hoisted_58 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "G.N", -1))
const _hoisted_60 = { class: "d-flex gap-3 mt-3" }
const _hoisted_61 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Cidade", -1))
const _hoisted_63 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Bairro", -1))
const _hoisted_65 = { class: "d-flex flex-column gap-1 container-input" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Número", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", _hoisted_3, [
      (_ctx.openCreateStore.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              (!_ctx.groupSelected.toString().length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.groupSelected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupSelected) = $event)),
              placeholder: "Selecione um grupo",
              clearable: "",
              class: "w-100"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeGroups, (group, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: group.nome,
                    value: group.id,
                    key: key
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            (_ctx.cnpjOk)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "* CNPJ já cadastrado na base"))
              : _createCommentVNode("", true),
            (!_ctx.dadosLoja.CNPJ)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
              : _createCommentVNode("", true)
          ]),
          (_ctx.openCreateStore.status)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
                clearable: "",
                modelValue: _ctx.dadosLoja.CNPJ,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dadosLoja.CNPJ) = $event)),
                maxlength: "18",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCnpjOk()))
              }, null, 8, ["disabled", "modelValue"])), [
                [_directive_maska, { mask:'##.###.###/####-##' }]
              ])
            : _withDirectives((_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: _ctx.dadosLoja.CNPJ,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dadosLoja.CNPJ) = $event)),
                maxlength: "18"
              }, null, 8, ["modelValue"])), [
                [_directive_maska, { mask: '##.###.###/####-##' }]
              ]),
          (_ctx.groupSelected === 82 || _ctx.groupSelected === 90)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                disabled: _ctx.cnpjOk,
                class: "btn texto",
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarIntegracao(_ctx.dadosLoja.CNPJ)))
              }, " Buscar integração ", 8, _hoisted_20))
            : _createCommentVNode("", true),
          (_ctx.dadosLoja.codGrupo === 82 || _ctx.dadosLoja.codGrupo === 90)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "btn texto",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.buscarIntegracao(_ctx.dadosLoja.CNPJ)))
              }, "Atualizar credenciais"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (!_ctx.dadosLoja.nomefantasia)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_input, {
            disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
            modelValue: _ctx.dadosLoja.nomefantasia,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dadosLoja.nomefantasia) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("ul", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, [
            _hoisted_31,
            (!_ctx.dadosLoja.razaoSocial)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_input, {
            disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
            modelValue: _ctx.dadosLoja.razaoSocial,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dadosLoja.razaoSocial) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _createElementVNode("li", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_el_input, {
            disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
            modelValue: _ctx.dadosLoja.telefone,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dadosLoja.telefone) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createVNode(_component_el_input, {
            disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
            modelValue: _ctx.dadosLoja.email,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dadosLoja.email) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.dadosLoja.created_at,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dadosLoja.created_at) = $event)),
            style: {"width":"100%"},
            type: "date",
            placeholder: "Pick a day",
            size: "default",
            format: "DD/MM/YYYY",
            disabled: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createVNode(_component_el_input, {
            disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
            modelValue: _ctx.dadosLoja.responsavel,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dadosLoja.responsavel) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _createElementVNode("li", _hoisted_46, [
          _hoisted_47,
          _createVNode(_component_el_input, {
            disabled: !_ctx.groupSelected.toString().length && _ctx.openCreateStore.status,
            modelValue: _ctx.dadosLoja.rede,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dadosLoja.rede) = $event))
          }, null, 8, ["disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.endereco,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dadosLoja.endereco) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _withDirectives(_createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.cep,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dadosLoja.cep) = $event)),
            maxlength: "9"
          }, null, 8, ["modelValue"]), [
            [_directive_maska, { mask:'#####-###' }]
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.uf,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dadosLoja.uf) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.logradouro,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dadosLoja.logradouro) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.gn,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dadosLoja.gn) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.cidade,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dadosLoja.cidade) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.bairro,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dadosLoja.bairro) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createVNode(_component_el_input, {
            modelValue: _ctx.dadosLoja.numero,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dadosLoja.numero) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}